module.exports = __webpack_public_path__ + "static/media/notice-5.3608cef3.jpg";